export default {
  OVERLAY: 'OVERLAY',
  STEP: 'STEP',
};
